<template>
    <section>
        <div class="text-xs">
            <p>{{currentDate}} {{currentMonth()}}, {{currentYear}}</p>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            currentDate : new Date().getUTCDate().toString(),
            currentYear: new Date().getFullYear(),
        }
    },

    methods : {
        currentMonth() {
            const months =["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            const d = new Date();
            const monthName = months[d.getMonth()];
            return (monthName)
        },
    }
}
</script>
